/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Link Icon (Nebula linkOutlinedRegular)
 *
 * @file LinkIcon.jsx
 * @author Gladson Samuel S
 * @since 3.1.0
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import PropTypes from 'prop-types';

const LinkIcon = ({ className, sx, ...props }) => (
  <SvgIcon
    {...props}
    className={className}
    viewBox="0 0 16 16"
    sx={{
      width: 16,
      height: 16,
      fontSize: 16,
      ...sx
    }}
  >
    <path d="M6.66679 4.16667C6.94288 4.16673 7.16679 4.39057 7.16679 4.66667C7.16679 4.94277 6.94288 5.1666 6.66679 5.16667H5.49426L5.34387 5.17122C4.99331 5.18941 4.64872 5.26493 4.3263 5.39518C3.95786 5.54404 3.62663 5.76085 3.35104 6.0306L3.34908 6.0319C2.93748 6.43118 2.66213 6.93287 2.55286 7.47266C2.44369 8.01214 2.50464 8.57036 2.72864 9.07943C2.95287 9.58893 3.33234 10.0296 3.82434 10.3431C4.31651 10.6566 4.89793 10.8281 5.49622 10.8333H6.66679C6.94288 10.8334 7.16679 11.0572 7.16679 11.3333C7.16679 11.6094 6.94288 11.8333 6.66679 11.8333H5.48775C4.7053 11.8265 3.93968 11.6023 3.28658 11.1862C2.6334 10.77 2.11968 10.1786 1.81327 9.48242C1.50666 8.78569 1.42258 8.01738 1.57304 7.27409C1.72331 6.53183 2.09966 5.85138 2.65117 5.31575L2.79374 5.18294C3.1335 4.88206 3.5258 4.64027 3.95195 4.4681C4.43893 4.27139 4.96177 4.16909 5.48971 4.16667H6.66679Z" fill="currentColor" />
    <path d="M10.6479 4.16927C11.3824 4.19556 12.0979 4.4153 12.7137 4.80729C13.3706 5.22554 13.8865 5.82263 14.1922 6.52539C14.498 7.22851 14.5788 8.00377 14.4227 8.75195C14.2666 9.49928 13.8817 10.182 13.3217 10.7161C12.9503 11.0732 12.5092 11.3556 12.0249 11.5469C11.5412 11.7378 11.0231 11.8343 10.5008 11.8327L9.33346 11.8333C9.05732 11.8333 8.83347 11.6095 8.83346 11.3333C8.83346 11.0572 9.05731 10.8333 9.33346 10.8333H10.5027C10.8996 10.8347 11.2923 10.7608 11.6577 10.6165C12.0231 10.4722 12.3531 10.2606 12.629 9.99544L12.631 9.99414C13.0486 9.59619 13.3298 9.09208 13.4435 8.54753C13.5571 8.00315 13.4993 7.43829 13.2755 6.92383C13.0516 6.40915 12.6702 5.96534 12.1766 5.65104C11.7443 5.3759 11.2435 5.21145 10.7241 5.17448L10.5001 5.16667H9.33346C9.05731 5.16667 8.83346 4.94281 8.83346 4.66667C8.83346 4.39052 9.05731 4.16667 9.33346 4.16667H10.5008L10.6479 4.16927Z" fill="currentColor" />
    <path d="M10.6668 7.5C10.9429 7.50007 11.1668 7.7239 11.1668 8C11.1668 8.2761 10.9429 8.49993 10.6668 8.5H5.33346C5.05731 8.5 4.83346 8.27614 4.83346 8C4.83346 7.72386 5.05731 7.5 5.33346 7.5H10.6668Z" fill="currentColor" />
  </SvgIcon>
);

LinkIcon.propTypes = {
  className: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func])
};

LinkIcon.defaultProps = {
  className: undefined,
  sx: undefined
};

export default LinkIcon;
